// @ts-nocheck
import * as React from "react";
import { Field } from "formik";
import StyledDatePicker from "./StyledDatePicker";
import { DatePickerProps } from "./StyledDatePicker";
import { FieldErrorMessage } from "src/components/Forms/ErrorMessage";

interface Props {
  name: string;
  disabled?: boolean;
  size?: any;
}
type InputProps = Omit<DatePickerProps, "size">;

const FormikInput: React.FC<Props & InputProps> = props => {
  return (
    <Field name={props.name}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { touched, errors, handleBlur, setFieldValue, setFieldTouched },
      }) => (
        <>
          <StyledDatePicker
            {...props}
            {...field}
            onBlur={e => {
              setFieldTouched(field.name, true);
            }}
            onChange={(date, dateString) => {
              setFieldTouched(field.name, true);
              setFieldValue(field.name, date);
            }}
            data-cy={`input-${field.name.replace(" ", "-")}`}
          />
          <FieldErrorMessage
            errors={errors}
            touched={touched}
            mt={20}
            name={field.name}
          />
        </>
      )}
    </Field>
  );
};

export default FormikInput;
